import React, { Fragment } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getUserRole } from '../../../helpers/AxiosAPI';

import AccessDenied from '../../AccessDenied';
import AriPage from './ari';
import AriPage2 from './arispace';
import ConversationsPage from './ConversationsIndex';
import VoucherWebisteIntregation from './integration/components/VoucherIntegrationList';
import OngoingConversationsPage from './ongoingconversations';
import BookingsPage from './bookings';
// import TicketsPage from './tickets';
import PropInfoPage from './propinfo';
import DiscountsPage from './discounts';
import FinancePage from './finance';
import AdminPage from './admin';
import IntegrationPage from './integration';
import IntegrationList from './integration/components/IntegrationList';
import PersistentMenu from './integration/components/PersistentMenu';
import BookingEngineUrlIntegrationList from './integration/components/BookingEngineUrlIntegrationList';
import FacebookIntegrationList from './integration/components/FacebookIntegrationList';
import GoogleBusinessIntegrationList from './integration/components/GoogleBusinessIntegrationList';
import WhatsappIntegrationList from './integration/components/WhatsApp/WhatsappIntegrationList';
import { RuleForm } from './integration/components/RuleForm';
import StandalonePageIntegrationList from './integration/components/ServiceStandalone/StandalonePageIntegrationList';
import EmbedPageIntegrationList from './integration/components/EmbedPage/EmbedPageIntegrationList';
import StandaloneGuestServicePageIntegrationList from './integration/components/GuestServiceStandalone/StandaloneGuestServicePageIntegrationList';
import HelpCenterIntegrationList from './integration/components/HelpCenter/HelpCenterIntegrationList';
import HelpCenterGroupIntegrationList from './integration/components/HelpCenterGroup/HelpCenterGroupIntegrationList';
// import GroupsPage from './groups';
// import PropertiesPage from './properties';
import UsersPage from './users';
import RatesBookingPage from './ratesbookings';
import BillingPage from './billing';
import BotDialogPage from './botdialogs';
import AccommodationProvidersDialogPage from './botdialogs/AccommodationProviders';
import DoctorsDialogPage from './botdialogs/Doctors';
import HolidayHomesDialogPage from './botdialogs/HolidayHomes';
import HolidaysParkDialogPage from './botdialogs/HolidaysPark';
import QuarantineBotDialogPage from './botdialogs/QuarantineBot';
import SalonsDialogPage from './botdialogs/Salons';
import TourismDialogPage from './botdialogs/Tourism';
import VirtualVetNurseDialogPage from './botdialogs/VirtualVetNurse';
import RetirementHomesDialogPage from './botdialogs/RetirementHomes';
import VouchersPage from './discounts/vouchers';
import OrdersPage from './discounts/orders';
import StripePage from './stripe';
import SalesforcePage from './salesforce';
import InvitationPage from './discounts/invitations';
import SuperAdmin from './superadmin';
import Insights from './discounts/Insights';
import CloudBeds from './cloudBeds/index';
import MeetingRooms from './meetingRooms';
import SpaceBookingPage from './spaceBookings';
import SpaceSettings from './arispace/Settings';
import SpaceStandaloneIntegrationList from './integration/components/SpaceStandalone/SpaceStandaloneIntegrationList';
import BusinessSettings from './businessSettings/Index';
import PhoneSuiteIntegrationList from './integration/components/PhoneSuite/PhoneSuiteIntegrationList';
import Faq from './FAQ';
import Document from './Documents';
import AgentAssist from './agentAssist';
import RESTApiIntegrationList from './integration/components/RESTApi/RESTApiIntegrationList';
import Instagram from './instagram';
import InstagramIntegrationList from './integration/components/InstagramIntegrationList';
import EmailIntegrationList from './integration/components/Email/EmailIntegrationList';
import Contacts from './contacts';
import ContactInfo from './contacts/components/contactInfo';
import MissedResponse from './MissedResponses/Index';
const Pages = ({ match }) => (
  <div className="dashboard-wrapper">
    {getUserRole() === "Agent" ?
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/data-list`} />
        <Route path={`${match.url}/agent-assist`} component={AgentAssist} />
        <Redirect to="/access-denied"></Redirect>
      </Switch>
      :
      getUserRole() === "NA" ?
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/data-list`} />
          <Redirect to="/access-denied" />
        </Switch>
        :
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/data-list`} />
          <Route path={`${match.url}/ari`} component={AriPage} />
          <Route path={`${match.url}/arispace`} component={AriPage2} />

          <Route
            path={`${match.url}/conversations`}
            component={ConversationsPage}
          />
          <Route path={`${match.url}/contacts`} component={Contacts} />
          <Route
            path={`${match.url}/latestconversations`}
            component={OngoingConversationsPage}
          />
          <Route path={`${match.url}/spacebookings`} component={SpaceBookingPage} />

          <Route path={`${match.url}/agent-assist`} component={AgentAssist} />

          <Route path={`${match.url}/bookings`} component={BookingsPage} />
          {/* <Route path={`${match.url}/tickets`} component={TicketsPage} /> */}
          <Route path={`${match.url}/propinfo`} component={PropInfoPage} />
          <Route path={`${match.url}/rate-promos`} component={DiscountsPage} />
          <Route path={`${match.url}/instagram`} component={Instagram} />
          <Route path={`${match.url}/finance`} component={FinancePage} />
          <Route path={`${match.url}/faq`} component={Faq} />
          <Route path={`${match.url}/documents`} component={Document} />
          <Route path={`${match.url}/integration`} component={IntegrationPage} />
          <Route
            path={`${match.url}/integrationdetail/:id`}
            component={IntegrationList}
          />
          <Route
            path={`${match.url}/space-standalone-detail/:id`}
            component={SpaceStandaloneIntegrationList}
          />
          <Route
            path={`${match.url}/phone-suite-detail/:id`}
            component={PhoneSuiteIntegrationList}
          />

          <Route
            path={`${match.url}/rest-api-detail/:id`}
            component={RESTApiIntegrationList}
          />
          <Route
            path={`${match.url}/contact-details/:id`}
            component={ContactInfo}
          />

          <Route path={`${match.url}/spaceSettings`} component={SpaceSettings} />
          <Route
            path={`${match.url}/facebookdetail/:id`}
            component={FacebookIntegrationList}
          />
          <Route
            path={`${match.url}/instagramdetail/:id`}
            component={InstagramIntegrationList}
          />
          <Route
            path={`${match.url}/google-bussiness-detail/:id`}
            component={GoogleBusinessIntegrationList}
          ></Route>
          <Route
            path={`${match.url}/whatsapp-detail/:id`}
            component={WhatsappIntegrationList}
          ></Route>
          <Route
            path={`${match.url}/booking-engine-url`}
            key="add-client"
            component={BookingEngineUrlIntegrationList}
          />
          <Route
            path={`${match.url}/booking-engine-url/:id`}
            key="edit-client"
            component={BookingEngineUrlIntegrationList}
          />

          <Route
            path={`${match.url}/standaloneintegrationdetail/:id`}
            component={StandalonePageIntegrationList}
          />
          <Route
            path={`${match.url}/embedintegrationdetail/:id`}
            component={EmbedPageIntegrationList}
          />
          <Route
            path={`${match.url}/standalone-guestservice-integrationdetail/:id`}
            component={StandaloneGuestServicePageIntegrationList}
          />
          <Route
            path={`${match.url}/helpcenter-integrationdetail/:id`}
            component={HelpCenterIntegrationList}
          />
          <Route
            path={`${match.url}/helpcenter-group-integrationdetail/:id`}
            component={HelpCenterGroupIntegrationList}
          />
          <Route
            path={`${match.url}/email-integrationdetail/:id`}
            component={EmailIntegrationList}
          />
          <Route
            path={`${match.url}/persistentmenu/:id`}
            component={PersistentMenu}
          />
          <Route path={`${match.url}/rules/:id`} component={RuleForm}></Route>
          <Route
            path={`${match.url}/voucherintegrationdetail/:id`}
            component={VoucherWebisteIntregation}
          />
          {getUserRole() === "User" ? <Redirect to="/access-denied" /> : <Route path={`${match.url}/admin`} component={AdminPage} />}
          <Route path={`${match.url}/spaces`} component={MeetingRooms} />
          {/* <Route path={`${match.url}/groups`} component={GroupsPage} />
               <Route path={`${match.url}/properties`} component={PropertiesPage} /> */}
          <Route path={`${match.url}/users`} component={UsersPage} />
          <Route
            path={`${match.url}/rates-bookings`}
            component={RatesBookingPage}
          />
          <Route path={`${match.url}/vouchers`} component={VouchersPage} />
          <Route path={`${match.url}/orders`} component={OrdersPage} />
          <Route path={`${match.url}/insights`} component={Insights} />

          <Route path={`${match.url}/invitations`} component={InvitationPage} />
          <Route path={`${match.url}/billing`} component={BillingPage} />
          <Route path={`${match.url}/botdialogs`} component={BotDialogPage} />
          <Route path={`${match.url}/sa`} component={SuperAdmin} />
          <Route path={`${match.url}/cloudbeds`} component={CloudBeds} />

          <Route
            path={`${match.url}/botdialogs/accommodationproviders`}
            component={AccommodationProvidersDialogPage}
          />
          <Route
            path={`${match.url}/botdialogs/doctors`}
            component={DoctorsDialogPage}
          />
          <Route
            path={`${match.url}/botdialogs/holidayhomes`}
            component={HolidayHomesDialogPage}
          />
          <Route
            path={`${match.url}/botdialogs/holidaypark`}
            component={HolidaysParkDialogPage}
          />
          <Route
            path={`${match.url}/botdialogs/quarantinebot`}
            component={QuarantineBotDialogPage}
          />
          <Route
            path={`${match.url}/botdialogs/salons`}
            component={SalonsDialogPage}
          />
          <Route
            path={`${match.url}/botdialogs/tourism`}
            component={TourismDialogPage}
          />
          <Route
            path={`${match.url}/botdialogs/vvn`}
            component={VirtualVetNurseDialogPage}
          />
          <Route
            path={`${match.url}/botdialogs/retirementhomes`}
            component={RetirementHomesDialogPage}
          />
          <Route path={`${match.url}/stripe`} component={StripePage}></Route>
          <Route
            path={`${match.url}/salesforce`}
            component={SalesforcePage}
          ></Route>
          <Route
            path={`${match.url}/business-settings`}
            component={BusinessSettings}
          ></Route>
          <Route path={`${match.url}/missed-responses`} component={MissedResponse}></Route>

          <Redirect to="/error" />
        </Switch>
    }
  </div>
);
export default Pages;
